export class ValidatorInput {

    /**
     * Datentyp, welcher eine Validierung an der Oberfläche kapselt
     *
     * @param name             Ein technischer Identifier
     * @param value            Dieser Wert soll später von Angular genutzt werden: <input [ngModel]="myModel.myField.value">
     * @param label            Ein lesbarer Name für das Feld, welcher später an der Oberfläche bei eventuellen Fehlermeldungen gezeigt wird
     * @param regex            Eigener Regex der geprüft wird, wenn in checkMask das Flag ValidationChecks.CUSTOM_REGEX_CHECK gesetzt ist
     * @param errorMsg         Ggf. irreführende Bezeichnung des Parameters; Dieses Feld wird dynamisch vom Validator gefüllt und kann an der View angezeigt werden
     * @param useThisErrorMsg  Wenn true, wird eine vordefinierte Fehlermeldung angezeigt; ansonsten schreibt der Validator die Fehlermeldung dynamisch rein
     * @param checkMask        Flags für Prüfungen. Siehe ValidationChecks in validation-checks.enum.ts.
     * @param checkFunction    Wenn die Standard-Validatoren nicht ausreichen kann hier kann optional eine eigene Validierungs-Funktion übergeben werden
     * @param valid            Der Validator will setzt diesen Wert auf false, wenn die Validation fehlschlägt. Inital wird von valid=true ausgegangen.
     */
    constructor(
        public name: string,
        public value: any,
        public label: string,
        public regex: RegExp,
        public errorMsg: string,
        public useThisErrorMsg: boolean = false,
        public checkMask: number = 0,
        public checkFunction: (validatorInput: ValidatorInput) => void = null,
        public valid: boolean = true,
    ) {
    }

}
